import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginForm from "./Login/Login";
import Home from "./Home/Home";
import Layout from "./Layout";
import Clients from "./Clients";
import Form from "./Clients/clientForm";
import Pos from "./Pos/Pos";
import PosForm from "./Pos/posForm";
import Cookies from "js-cookie"; // Import js-cookie to check token in cookies
import Offers from "./Offers/Offers";
import OfferForm from "./Offers/offerForm";
import Transactions from "./Transactions/Transactions";
import PointScore from "./PointScore/PointScore";
import CryptoJS from "crypto-js";
import Error from "./Components/Error 404/Error404";
import VoucherPage from "./Vouchers/Voucher";
import BannersMobile from "./BannersMobile/BannersMobile";
import CustomerGroup from "./CustomerGroup/CustomerGroup";
import CustomerGForm from "./CustomerGroup/customerGroupForm";
import 'swiper/swiper-bundle.min.css';
import Notifications from "./Notifications/Notifications";
import NotificationsForm from "./Notifications/NotificationsForm";
import Banners from "./Banners/Banners";
import NettingReport from "./NettingReport/NettingReport";
import BonusLevel from "./Components/BonusLevel/BonusLevel";
import OnboardingScreens from "./OpeningScreen/OpeningScreen";
import Levels from "./Levels/Levels";





function App() {
  
  const getDecryptedToken = () => {
    const encryptedToken = Cookies.get("token");
    if (!encryptedToken) return null;

    const secretKey = '19092002'; 
    const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedToken || null;
  };

 
  const token = getDecryptedToken();
  

  return (
    <Routes>
    
      <Route path="/" element={token ? <Navigate to="/Home" /> : <LoginForm />} />
      <Route path="/bannersadmin/:theme" element={<BannersMobile />} />
      <Route path="/bonuslevel/:userId/:theme" element={<BonusLevel />} />
      <Route path="/onboardingscreen/:theme" element={<OnboardingScreens />} />

      {token && (
        <Route element={<Layout />}>
          <Route path="/Home" element={<Home />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/clientForm" element={<Form />} />
          <Route path="/pos" element={<Pos />} />
          <Route path="/posForm" element={<PosForm />} />
          <Route path="/offers" element = {<Offers />}/>
          <Route path="/offerForm" element= {<OfferForm />}/>
          <Route path="/transactions" element= {<Transactions />} />
          <Route path="/bonuspointsvalue" element = {<PointScore />} />
          <Route path="/voucher" element ={<VoucherPage />} />
          <Route path="/customergroup" element ={<CustomerGroup />} />
          <Route path="/customergroupForm" element ={<CustomerGForm />} />
          <Route path ="/notifications" element={<Notifications />} />
          <Route path ="/notificationsForm" element={<NotificationsForm />} />
          <Route path = "/banners" element={<Banners />} />
          <Route path = '/nettingreport' element = {<NettingReport />} />
          <Route path ='/levels' element = {<Levels />} />
       
        </Route>
      )}
      
    
      <Route path="/Home" element={token ? <Home /> : <Navigate to="/" />} />

      <Route path="*" element={<Error />} />
    </Routes>

    
  );
}

export default App;
